import React, { useState, useRef, useEffect } from "react";
import { endPoints } from "../../constant/Environment";
import { addData, getAllData } from "../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import FormControlLabel from "@mui/material/FormControlLabel";
import "./TableStyles.css";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";

import FormControl from "@mui/material/FormControl";
import moment from "moment";
import Select from "@mui/material/Select";

const BounsCsv = (props) => {
  const { onClose, open } = props;
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [campaignList, setCampaignList] = useState([]);
  const [campaignId, setCampaignId] = useState("");
  const [creditBonus, setCreditBonus] = useState(0);
  const [debitBonus, setDebitBonus] = useState(0);

  const handleCancel = () => {
    onClose();
  };

  useEffect(() => {
    getAllCampaignList();
    setDebitBonus();
    setCreditBonus();
  }, []);

  useEffect(() => {
    getAllCampaignList();
    setDebitBonus();
    setCampaignId("");
    setCreditBonus();
    setData([]);
  }, [open]);

  const getAllCampaignList = () => {
    let url = `${endPoints.api.GET_ALL_ACTIVE_CAMPAIGN}`;
    getAllData(url)
      .then((response) => {
        const { status, data, message } = response;

        if (status === "success") {
          setCampaignList(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    setIsLoading(false);

    reader.onload = (e) => {
      const text = e.target.result;
      // Assuming the CSV contains only one column of customer IDs
      const idsArray = text.split("\n").map((row) => row.trim());
      const rows = text.split("\n");
      // Assuming the first row contains the headers
      const headers = rows[0].split(",").map((header) => header.trim());
      // Map each row to an object
      const data = rows.slice(1).map((row) => {
        const values = row.split(",").map((value) => value.trim());
        let rowData = {};
        headers.forEach((header, index) => {
          rowData[header] = values[index];
        });
        return rowData;
      });
     // data.shift();

      let convertedData = data.map((item) => {
        // const expiryDate = item["Bonus Expiration Date"]

        // console.log('expiryDate',expiryDate)
        // const currentTime = moment(new Date(expiryDate)).tz('America/New_York').format('YYYY-MM-DDTHH:mm:ss');

        // console.log('currentTime',currentTime)
        // const date = new Date(expiryDate);
        
       // const isoString = date?.toISOString();

        const dateString = item["Bonus Expiration Date"]

        // // Parse the input date string
        // const [day, month, year] = dateString?.split(' ')[0]?.split('/') || dateString?.split(' ')[0]?.split('-');
        // const [hours, minutes, seconds] = dateString?.split(' ')[1].split(':');
        
        // // Create the formatted string
        // const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.000Z`;

  
const momentObj = moment(dateString, 'DD/MM/YYYY HH:mm:ss');

// Convert to ISO 8601 format with milliseconds and set it to UTC
const isoString = momentObj.utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');

console.log(isoString); // Output: 2024-08-15T17:14:45.000Z
        

      //  console.log("isoString", isoString);

        return {
          idUser: item["Customer ID"],
          amount: item["Bonus Amount"],
          transactionType: item["Transaction Type"],
          idCampain: campaignId,
          expiryDate:isoString , // isoString,
          bonusType:2,//  item["Bonus Type"],
        };
      });

      setData(convertedData);

      console.log(convertedData);
      calculateTotalBonus(convertedData);
    };

    reader.readAsText(file);
  };

  const calculateTotalBonus = (data) => {
    const debitRecord = data.filter((item) => item.transactionType == "Debit");
    const creditRecord = data.filter(
      (item) => item.transactionType == "Credit"
    );
    if (debitRecord.length > 0) {
      const total = debitRecord.reduce(
        (acc, row) => acc + parseFloat(row.amount),
        0
      );
      setDebitBonus(total);
    }
    if (creditRecord.length > 0) {
      const total = creditRecord.reduce(
        (acc, row) => acc + parseFloat(row.amount),
        0
      );
      setCreditBonus(total);
    }
  };

  const handleOk = () => {
    //bonus/bulkadd
    let url = `${endPoints.api.CREATE_BULK_BOUNS}`;

    // let payload = {
    //   data: data,
    // };
    setIsLoading(true);
    addData(url, data)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);

          onClose();
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
  };

  const handleChange = (event) => {
    setCampaignId(event.target.value);
  };
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href =   'https://bettdraftimages.s3.amazonaws.com/BulkBonus.csv ' //  hardcoded S3 URL; previously used PUBLIC_URL/BulkBonus.csv
    link.download = "BulkBonus.csv"; // The name of the file to be downloaded
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Clean up after clicking
  };

  return (
    <Dialog
      xl={{ "& .MuiDialog-paper": { width: "100%", maxHeight: 435 } }}
      maxWidth="lg"
      open={open}
    >
      <DialogTitle> Bulk Bonus Info </DialogTitle>

      <DialogContent dividers>
        <Toaster></Toaster>
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button onClick={handleDownload}>Download Sample File</Button>
        </div>

        <FormControl style={{ width: "100%", marginTop: "15px" }}>
          <InputLabel id="demo-simple-select-helper-label">
            Select Campagin
          </InputLabel>

          <Select
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            value={campaignId}
            label="Secert Question"
            onChange={handleChange}
            style={{ width: "100%" }}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {campaignList.map((option) => (
              <MenuItem value={option.idCampaign}>
                {option.campaignName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <label>UserList</label>
          <Form.Control
            style={{ marginBottom: "20px", width: "100%" }}
            id="filled-required"
            variant="outlined"
            label="image"
            name={data}
            type="file"
            onChange={handleFileUpload}
            accept=".csv"
            disabled={campaignId == "" ? true : false}
          />
        </FormControl>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h4>Total Credit Bonus: {creditBonus}</h4>
          <h4>Total Debit Bonus: {debitBonus}</h4>
        </div>

        <table id="bulkTable">
          <thead>
            <tr>
              <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                Customer ID
              </th>

              <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                Bonus Amount
              </th>
              <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                Transaction Type
              </th>
              <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                Campaign ID
              </th>

              <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                Bonus Expiration Date
              </th>
              <th style={{ padding: "8px", border: "1px solid #ddd" }}>
                Bonus Type
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={index}>
                <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                  {row.idUser}
                </td>

                <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                  {row.amount}
                </td>
                <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                  {row.transactionType}
                </td>
                <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                  {row.idCampain}
                </td>

                <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                  {row.expiryDate}
                </td>
                <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                  {'Bouns' }
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel}>
          Cancel
        </Button>
        <Button onClick={handleOk}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
};

export default BounsCsv;
